<template>
  <div 
    v-if="progress !== null"
    class="progress-container"
  >
    <div class="progress-bar">
      <div 
        class="progress-fill"
        :style="{ width: progress + '%' }"
      ></div>
    </div>
    <p class="tw-text-xs tw-text-gray-500 tw-mt-2 tw-text-center">
      Step {{ currentStep }} of {{ totalSteps }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ProgressIndicator',
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    totalSteps: {
      type: Number,
      required: true
    }
  },
  computed: {
    progress() {
      if (this.totalSteps === 0) return 0;
      return Math.round((this.currentStep / this.totalSteps) * 100);
    }
  }
};
</script>

<style scoped>
.progress-container {
  @apply tw-px-8 tw-pt-8;
}

.progress-bar {
  @apply tw-w-full tw-h-2 tw-bg-gray-200 tw-rounded-full tw-overflow-hidden;
}

.progress-fill {
  @apply tw-h-full tw-bg-gradient-to-r tw-from-blue-500 tw-to-purple-500;
  @apply tw-transition-all tw-duration-500 tw-ease-out;
  @apply tw-rounded-full;
}

@media (max-width: 768px) {
  .progress-container {
    @apply tw-px-6;
  }
}
</style>
